export enum RightSideBarType {
  NONE,
  CHAT_INFO,
  PEER_INFO,
  MEMBER_INFO,
}

export default RightSideBarType;
